import cx from 'classnames2';
import React from 'react';

import { Input, ValidationStates } from '../Input';
import { InputGroup } from '../InputGroup';

import styles from './ColorInput.module.scss';

export interface IColorInputProps {
  color?: string;
  size?: 'default' | 'small';
  validationState?: ValidationStates;
  onChange?(value: string): void;
  onBlur?(value: string): void;
}

export class ColorInput extends React.Component<IColorInputProps> {
  static defaultProps = {
    size: 'default',
    onChange: () => {}
  };

  cleanInputString = (value) => {
    // Strip hash sign if present
    if (value && value.match(/#/g) && value.match(/#/g).length) {
      return value.replace('#', '');
    }

    return value;
  };

  handleChange = (value) => {
    this.props.onChange(`#${value}`);
  };

  render() {
    const hasError = this.props.validationState === ValidationStates.Error;
    const isSmall = this.props.size === 'small';
    const isDefault = this.props.size === 'default';

    const inputStyles = cx({
      [styles.inputDefault]: isDefault,
      [styles.inputSmall]: isSmall,
      [styles.inputError]: hasError
    });

    const hexPrefixStyles = cx(styles.hexPrefix, {
      [styles.hexPrefixDefault]: isDefault,
      [styles.hexPrefixSmall]: isSmall
    });

    const colorSwatchWrapperStyles = cx({
      [styles.colorSwatchWrapperDefault]: isDefault,
      [styles.colorSwatchWrapperSmall]: isSmall
    });

    const colorSwatchStyles = cx({
      [styles.colorSwatchDefault]: isDefault,
      [styles.colorSwatchSmall]: isSmall
    });

    return (
      <div className={cx(styles.container, styles.error)}>
        <div className={hexPrefixStyles}>#</div>
        <InputGroup>
          <Input.Text
            dataTest="color-input"
            size={this.props.size}
            value={this.cleanInputString(this.props.color)}
            onChange={this.handleChange}
            onBlur={this.props.onBlur}
            inputClassName={inputStyles}
            maxLength={6}
            placeholder={'FFFFFF'}
          />
          <InputGroup.Suffix size={this.props.size}>
            {hasError ? (
              <InputGroup.Icon icon="status-error" dataTest="error-icon" />
            ) : (
              <div className={colorSwatchWrapperStyles}>
                <div
                  key={this.props.color}
                  data-test="color-input-swatch"
                  className={colorSwatchStyles}
                  style={{ backgroundColor: this.props.color || 'FFFFFF' }}
                />
              </div>
            )}
          </InputGroup.Suffix>
        </InputGroup>
      </div>
    );
  }
}
